<template>
	<div
		id="offerStatus-management"
		:class="[!isWeb ? 'mobile-offerStatus-management' : '', !isWeb && isSafari ? 'safari' : '']"
	>
		<div class="offerStatus-management__body">
			<TableFilter :isWeb="isWeb" @searchFromInput="searchFromInput" />
			<OfferStatusTable
				:isWeb="isWeb"
				:currentPage="page"
				@changePage="changePage"
				@refreshOfferStatus="refreshOfferStatus"
				@orderByHeader="orderByHeader"
			/>
		</div>
	</div>
</template>

<script>
import { mapActions } from 'vuex';
import { GET_ALL_OFFER_STATUS } from '@/store/modules/offerStatusManagement/actions';
import TableFilter from '@/components/modules/OfferStatus/OfferStatusManagement/TableFilter/TableFilter.vue';
import OfferStatusTable from '@/components/modules/OfferStatus/OfferStatusManagement/Table/Table.vue';

export default {
	name: 'OfferStatusManagement',
	components: { TableFilter, OfferStatusTable },
	data: () => ({
		windowWidth: window.innerWidth,
		page: 1,
		searchParams: null,
		headerSelected: null,
		orderSelected: null,
	}),
	created() {
		this.refreshOfferStatus();
	},
	mounted() {
		this.$nextTick(() => {
			window.addEventListener('resize', this.onResize);
		});
	},
	beforeDestroy() {
		window.removeEventListener('resize', this.onResize);
	},
	methods: {
		...mapActions('offerStatusManagement', {
			getOfferStatus: GET_ALL_OFFER_STATUS,
		}),
		onResize() {
			this.windowWidth = window.innerWidth;
		},
		changePage(params) {
			this.page = params.params;
			this.refreshOfferStatus();
		},
		searchFromInput(params) {
			this.searchParams = params.toString();
			this.page = 1;
			this.refreshOfferStatus();
		},
		orderByHeader(param) {
			this.headerSelected = param;

			if (!this.orderSelected || this.orderSelected == 'ASC') {
				this.orderSelected = 'DESC';
			} else {
				this.orderSelected = 'ASC';
			}

			this.refreshOfferStatus();
		},
		refreshOfferStatus() {
			let params = `?limit=20&page=${this.page}`;

			if (this.searchParams) {
				if (this.searchParams.includes('#')) {
					this.searchParams = this.searchParams.replace('#', '%23');
				}

				params += `&search=${this.searchParams}`;
			}

			if (this.headerSelected)
				params += `&orderColumn=${this.headerSelected}&orderDirection=${this.orderSelected}`;

			this.getOfferStatus({ vm: this, params: params });
		},
	},
	computed: {
		isWeb() {
			return this.windowWidth > 992;
		},
		isSafari() {
			return navigator.vendor == 'Apple Computer, Inc.';
		},
	},
};
</script>

<style lang="scss">
@import 'OfferStatusManagement.scss';
</style>
